import { createApp } from 'vue'
import App from './App.vue'
import Router from './router/router.js'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
// import 'default-passive-events'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
	app.component(key, component)
}
app.use(Router)
app.use(ElementPlus, {
	locale: zhCn
})
app.mount('#app')
